/** Delay in ms before touch long-press activates drag on mobile (used by TouchSensor and pre-drag feedback) */
export const DND_DELAY_MOBILE = 800;

/** Max movement (px) allowed during the long-press; exceeding this aborts drag (prevents accidental drags when scrolling) */
export const DND_MOBILE_TOLERANCE_PX = 12;

/** Droppable id for the zone above the first task - drop shows "before first" indicator */
export const DND_SENTINEL_BEFORE_FIRST = 'list-drop-before-first';

/** Droppable id for the zone below the last task - drop shows "after last" indicator */
export const DND_SENTINEL_AFTER_LAST = 'list-drop-after-last';
